import * as gs from "@ivanlog/gs";
import * as com from "../../plusx-lib/com/tmpls";
import { StatePaged } from "../../plusx-lib/states/abstracts/StatePaged";

export class StateLoading extends StatePaged<com.PageLoadingLPX> {
    static readonly StateName = "loading" ;

    constructor() {
        super(com.PageLoadingLPX, "LPX loading...", false);
    }

    public async start() {
        return super.start();
    }
}